import { Alert } from "antd";

export const AdminNotice = ({ 
  description,
  type = "warning",
  style = {}
}) => {

  const defaultDescription = (
    <span>
      You can only view this page because you are logged in with a staff account.<br/>
      This feature is currently <b>disabled</b> for this team. 
    </span>
  );

  return (
    <Alert 
        type={type}
        showIcon
        style={style}
        description={description || defaultDescription}
    />
  );
}; 